import { render, staticRenderFns } from "./EditMgtCategory.vue?vue&type=template&id=95a222d8"
import script from "./EditMgtCategory.vue?vue&type=script&lang=js"
export * from "./EditMgtCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports